import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import { dateFormat } from "./../Helper/common";

import UploadIcon from "../assets/img/upload-icon-blue.svg";
import '../assets/css/candidate-tab-form.css';

import {
    removeDocFolderInsuff,
    removeInsuffFile,
    saveInsuffData,
    uploadFileViaMultipartInsuff
} from "../Actions/InsuffFlowActions";
import '../assets/css/candidate-tab-form.css';
import { useNavigate } from 'react-router-dom';

const renderDragDropChildren = () => (
    <>
        <div className="col-md-12" style={{padding: 0}}>
            <div
                className="upload-box d-flex align-items-center justify-content-center flex-column kih-drap-drop insuff-drag-drop"
                style={{borderRadius: 5}}
            >
                {" "}
                <img src={UploadIcon} alt="" className="mb-2" />{" "}
                <div className="text-center pl-2 pr-2">
                    {" "}
                    <div
                        style={{
                            display: "contents",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        }}><a href="#">Click to upload</a>{" "}
                        <span className="text-muted">or drag and drop</span>
                    </div>
                    <br />{" "}
                    {/* {fileUpLoaded != null ? <h6>{fileUpLoaded.name}</h6> : ""} */}
                    <span className="text-muted">
                    PNG, JPG, JPEG, ZIP, PDF, DOC or DOCX ( max file size 25MB in total )
                    </span>{" "}
                </div>
            </div>
        </div>
    </>
)

const InsuffComponent = (props) => {
    const navigate=useNavigate();
    // const InsuffFileData = useSelector((state) => state?.InsuffFileData);
    const { allDetails , insuffData, insuffFileList, lastCheck } = props;
    //Handling Initial States Floating Labels
    const [formData, setFormData] = useState({});
    const form = useRef();

    const [fileSize, setFileSize] = useState(0);

    const dispatch = useDispatch();

    const fileTypes = ['jpg', 'jpeg', 'png', 'zip', 'pdf', 'doc', 'docx'];

    const [fileUpLoaded, setFileUpLoaded] = useState([]);

    const [fileError, setFileError] = useState(null);

    const [commentError, setCommentError] = useState(null);

    let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
    let clientId;
  
    if(user && (user?.client_id || user?.bridge_client_id)){
      clientId = user?.client_id || user?.bridge_client_id;  
    }

    useEffect(() => {
        if (insuffFileList?.length) {
            setFileError(null);
            let serverFilesSize = 0
            serverFilesSize = insuffFileList?.reduce(
                (totalSize, currentFile) => totalSize + (currentFile?.size || 0),
                0
            );
            setFileSize(((serverFilesSize / 1000) / 1000).toFixed(2));
        } else {
            setFileSize(0);
        }
    }, [insuffFileList])

    // useEffect(() => {
    //     if(Object.keys(formData)?.length){
    //         checkFieldErrors();
    //     }
    // },[formData])

    /**
     * 
     * @param {*} files
     * @func handles the file[s] uploads and runs the save api 
     */

    const handleChange = (files) => {
        // setFileSize(file.size);
        let fileArray = []
        let localFilesSize = 0;
        let serverFilesSize = 0;
        let totalFilesSize = 0;
        //4022684
        if (files) {
            Object.entries(files).map(file => {
                localFilesSize = localFilesSize + (file[1].size || 0);
                if (insuffFileList?.length) {
                    serverFilesSize = insuffFileList?.reduce(
                        (totalSize, currentFile) => totalSize + (currentFile?.size || 0),
                        0
                    );
                    const findExistingUpload = insuffFileList?.
                        find(uploadFile => uploadFile?.name === file[1].name);
                    // console.log("find Existing file..",findExistingUpload);
                    if (!(findExistingUpload)) {
                        fileArray.push(file[1]);
                    }
                } else {
                    fileArray.push(file[1]);
                }
                // console.log('serverFileSize...', serverFilesSize);
                // console.log('localFileSize...', localFilesSize);
                if (serverFilesSize || localFilesSize) {
                    totalFilesSize = (serverFilesSize + localFilesSize) / 1000 //convert bytes to kilobytes;
                    // setFileSize(parseFloat(totalFilesSize.toFixed(2)))
                    // setFileSize((totalFilesSize/1024).toFixed(2)); //convert kilobytes to megabytes;
                }
                // console.log('totalFilesSize....', parseFloat(totalFilesSize.toFixed(2)))
            });
        }

        setFileUpLoaded(prevState => ([
            ...prevState,
            ...fileArray,
        ]));
        // console.log("file...", files)
        if (totalFilesSize > 25000) {
            alert('File cannot be larger than 25MB');
        } else if (fileArray.length) {
            dispatch(uploadFileViaMultipartInsuff(insuffData?.CaseInsuffDetail?.INSUFF_ID, fileArray));
        }
        // }
    };

    /**
     * 
     * @param {*} e 
     * @func handles label styling and save data for comment field
     */
    const handleFloatingLabels = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    }

    /**
     * handle preview functionality
     */

    const handleSubmitForPreview = (e) => {
        let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
        const reference=list.reference_number;
        e.preventDefault();
        navigate(`/case-initiation/profile-preview/${reference}`);
      };

    /**
     * 
     * @param {*} e 
     * @func handles doc provided check box
     */
    const handleCheckBox = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e?.target?.name]: e?.target?.checked,
        }));
    }

    /**
     * 
     * @param {*} e
     * @func check for the required field and save the data through api 
     */
    const handleSaveData = (e) => {
        e.preventDefault();
        let formFilePathArray = []
        let formFilesData = ""
        const hasErrors = checkFieldErrors();
        if (!hasErrors) {
            // setFileError('')
            if (insuffFileList) {
                Object.entries(insuffFileList).map(file => {
                    formFilePathArray.push(file[1]?.awspath);
                })
                if (formFilePathArray?.length) {
                    formFilesData = formFilePathArray.join('@@@@');
                }
            }
            // console.log('file form data...', formFilesData)
            const requestObj = {
                "currObj": `${insuffData?.CaseInsuffDetail?.INSUFF_ID}`,
                "currcase": `${insuffData?.CaseInsuffDetail?.CASE_ID}`,
                "currcheck": `${insuffData?.CaseInsuffDetail?.CASE_CHECK_ID}`,
                "formData": `${formData?.comment || ''}`,
                "document_check": formData?.submitLater ? 'I dont have this document' : 'document',
                "formFilesData": formData?.submitLater ? '' : formFilesData,
                "last_check": lastCheck
            }

            if (formData?.comment) {
                // console.log('requestObj..', requestObj)
                dispatch(saveInsuffData(requestObj));
            }
        }
    }

    /**
     * 
     * @param {*} fileName  required for deleting specific file from redux
     * @param {*} deleteUrl required for deleting specific file through api
     * @func handle single delete and bulk delete both
     */
    const handleFileDelete = (fileName, deleteUrl) => {
        // console.log('delete initiated....', deleteUrl);
        if (fileName && deleteUrl) {
            dispatch(removeInsuffFile(fileName, { path: deleteUrl }))
        } else {
            dispatch(removeDocFolderInsuff({ random_folder: 'insuff' }))
        }
    }

    const checkFieldErrors = () => {
        let hasErrors = false;
        if (!formData.submitLater && !insuffFileList?.length) {
            setFileError('This field is required.');
            hasErrors = true
        } else {
            setFileError(null);
        }
        if (!formData.comment) {
            setCommentError('This field is required.');
            hasErrors = true
        } else {
            setCommentError(null);
        }
        return hasErrors;
    }

    // useEffect(() => {
    //     console.log('InsuffList...', insuffFileList);
    //     console.log('fileSize...',fileSize);
    //     console.log('fileError...',fileError);
    //     console.log('comment Error...',commentError);
    // })

    return (
        <>
            <form ref={form} className="p-3 form2 form-section">
                <h2 className="fnt-smi-bld">{`${insuffData?.CaseCheck?.CHECK_NAME}`}</h2>
                <p className="text-muted">Please provide the required information.</p>
                <hr />


                {
                   insuffData?.CaseInsuffDetail?.INSUFF_FULLFIL_REMARKS && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                    {/* <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Insuff Remark :</div> */}
                    <div className="col-sm-3 col-md-12 col-xl-auto" style={{fontSize:'16px',backgroundColor:' #FFFFFF',color:'#1D1D1D',borderRadius:'10px',padding:'12px',margin:'5px'}}>{`Note:${ insuffData?.CaseInsuffDetail?.INSUFF_FULLFIL_REMARKS}`}</div>
                </div>
                }
                

                {
                    insuffData?.CaseInsuffDetail?.INSUFFICIENCY && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                    {/* <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Insuff Remark :</div> */}
                    <div className="col-sm-3 col-md-12 col-xl-auto" style={{fontSize:'16px',backgroundColor:' #FEF3F2',color:'#B42318',borderRadius:'10px',padding:'12px',margin:'5px'}}>{` Remark: ${insuffData?.CaseInsuffDetail?.INSUFFICIENCY}`}</div>
                </div>
                }

                {/* {insuffData?.InsufficiencyRespondedCase?.STATUS == '2' &&
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-auto" style={{fontSize:'16px',backgroundColor:' #FEF3F2',color:'#B42318',borderRadius:'3px',padding:'4px'}}>{insuffData?.InsufficiencyRespondedCase?.INSUFF_REJECTION_REMARK || 'NA'}</div>
                    </div>
                } */}


                {/* {
                    insuffData?.InsufficiencyRespondedCase?.STATUS == '1' ?
                        <>
                            <div className="row mb-3">
                                <div className="col-sm-6 col-md-12 col-xl-6">
                                    <div className="alert alert-success">{`Status : Submitted`}</div>
                                </div>
                            </div>
                        </> : (insuffData?.InsufficiencyRespondedCase?.STATUS == '2'
                            || insuffData?.InsufficiencyRespondedCase?.STATUS == '3') ?
                            <>
                                <div className="row mb-3">
                                    <div className="col-sm-6 col-md-12 col-xl-6">
                                        <div className="alert alert-danger">{`Status : Pending - Referred Back`}</div>
                                    </div>
                                </div>
                            </> :
                            <>
                                <div className="row mb-3">
                                    <div className="col-sm-6 col-md-12 col-xl-6">
                                        <div className="alert alert-danger">{`Status : Pending`}</div>
                                    </div>
                                </div>
                            </>
                } */}

                    {
                        insuffData?.InsufficiencyRespondedCase?.STATUS == '1'?
                        <div style={{fontWeight:'bold',fontSize:"16px",textAlign:'center',color:'green'}}>
                            Insuff is fulfilled of current check
                        </div>:''
                    }

                         {
                             insuffData?.InsufficiencyRespondedCase?.STATUS != '1'?
                         
                          <>
                            <div className="row mt-4">
                                <div className="col-sm-6 col-md-12 col-xl-6">
                                    <div className="form-group mb-2">
                                        <div className="floating-label">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="comment"
                                                id="comment"
                                                onChange={(e) => {
                                                    if (e?.target?.value) {
                                                        setCommentError(null);
                                                    }
                                                    handleFloatingLabels(e)
                                                }
                                                }
                                            />
                                            <label
                                                htmlFor="comment"
                                                className={formData?.comment && 'focused'}
                                            >
                                                {`Add Comment (If any)`}
                                                <sup className="text-danger">*</sup>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                commentError &&
                                <p className="err text-danger">
                                    {`${commentError}`}
                                </p>
                            }
                            </>:''}




                {/* <h6 className="fnt-smi-bld mb-2 mt-4">Basic Candidate Information</h6> */}
                {/* {
                    allDetails?.bridge_case_candidate?.FIRST_NAME && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">First Name :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{allDetails?.bridge_case_candidate?.FIRST_NAME}</div>
                    </div>
                } */}

                {/* {
                    allDetails?.bridge_case_candidate?.LAST_NAME && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Last Name:</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{allDetails?.bridge_case_candidate?.LAST_NAME}</div>
                    </div>
                } */}
                {/* {
                    allDetails?.bridge_case_candidate?.EMAIL_ADDRESS && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Email Address :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{allDetails?.bridge_case_candidate?.EMAIL_ADDRESS}</div>
                    </div>
                } */}
                {/* {
                    allDetails?.bridge_case_candidate?.MOBILE_NO && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Mobile No :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{allDetails?.bridge_case_candidate?.MOBILE_NO}</div>
                    </div>
                } */}
                {/* {
                    allDetails?.bridge_case_candidate?.DATE_OF_BIRTH && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">DOB (Candidate) :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{dateFormat("DD-MM-YYYY", allDetails?.bridge_case_candidate?.DATE_OF_BIRTH)}</div>
                    </div>
                } */}
                {/* {
                    allDetails?.bridge_case_candidate?.FATHER_NAME && 
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Father's Name :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{allDetails?.bridge_case_candidate?.FATHER_NAME}</div>
                    </div>
                } */}



                {/* <h6 className="fnt-smi-bld mb-2 mt-4">Additional Field(s)</h6> */}
                {/* {
                    allDetails?.BridgeFlexField && allDetails?.BridgeFlexField?.map(field => {
                        let fieldValue = allDetails?.bridge_case_field 
                        ? allDetails[`bridge_case_field`][`CASE_FLEX_FIELD${field.FIELD_ID}`] : ''
                        return fieldValue ? 
                            <>
                                <div className="row mb-2" style={{ alignItems: 'flex-start' }}>
                                    <div className="col-sm-3 col-md-12 col-xl-3 text-muted">{`${field?.FIELD_NAME} :`}</div>
                                    <div className="col-sm-3 col-md-12 col-xl-auto">{`${fieldValue}`}</div>
                                </div>
                            </> :
                            <></>
                        
                    })
                } */}
                {/* {
                    !!((insuffData?.CaseCheck?.FAMILY_ID == '4' || insuffData?.CaseCheck?.FAMILY_ID == '5') 
                    && insuffData?.CaseInsuffDetail?.verification_src ) &&
                    <div className="row mb-2" style={{alignItems:'flex-start'}}>
                        <div className="col-sm-3 col-md-12 col-xl-3 text-muted">Verification Source :</div>
                        <div className="col-sm-3 col-md-12 col-xl-auto">{insuffData?.CaseInsuffDetail?.verification_src}</div>
                    </div>
                } */}
               
                 
                {
                    insuffData?.InsufficiencyRespondedCase?.STATUS != '1' ? 
                        <>

                            <label style={{fontWeight:'bold'}}>Upload Documents <sup className="text-danger">*</sup> </label>
                            <div className="row mt-2">
                                {" "}
                                <div className="uploader-wrapper col-sm-6 col-md-12 col-xl-6">
                                    <FileUploader
                                        hoverTitle={'Choose Files'}
                                        classes={'file-upload'}
                                        handleChange={handleChange}
                                        multiple={true}
                                        name="file"
                                        // maxSize="5"
                                        children={renderDragDropChildren()}
                                        // label="Upload or drop a file right here"
                                        // onSizeError={(file) => {
                                        //     alert("file size larger than 5 mb");
                                        // }}
                                        onTypeError={(file) => {
                                            alert("Invalid file format");
                                        }}
                                        types={fileTypes}
                                    />
                                </div>
                            </div>
                            {
                                fileError &&
                                <p className="err text-danger">
                                    {`${fileError}`}
                                </p>
                            }
                            <div
                            // style={{
                            //     display: 'grid',
                            //     gridTemplateColumns: '1fr 1fr',
                            //     maxWidth: 'max-content',
                            //     gridGap: 20,
                            //     marginTop: 20,
                            // }}
                            >



                                {
                                    !!(insuffFileList?.length) &&
                                    insuffFileList?.map(file => (
                                        <>
                                            <div className="row mt-4">
                                                <div className="col-sm-6 col-md-12 col-xl-6">
                                                    <div
                                                        className='files-upload-container'
                                                    >
                                                        <div className='item-wrapper' >
                                                            <div className='icon-name-container'>
                                                                <span className={"fa-regular fa-file"}></span>
                                                                <span className={"text-wrapper"}>{`${file?.name}`} </span>
                                                            </div>
                                                            <span className={"fas fa-window-close"} onClick={(e) => handleFileDelete(file?.name, file?.deleteUrl)}></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ))
                                }
                            </div>



                            {
                                !!(insuffFileList?.length) &&
                                <>
                                    <div className="row mt-4">
                                        <div className="col-sm-6 col-md-12 col-xl-6">
                                            <div className='files-upload-container'>
                                                <div className='item-wrapper'>
                                                    <div className='icon-name-container'>
                                                        <span className={"fa-regular fa-file"}></span>
                                                        <span className='text-wrapper'>{`${insuffFileList?.length} files Uploaded`} </span>
                                                    </div>
                                                    <span className={"fa-regular fa-trash-can"} onClick={(e) => handleFileDelete()}></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                            <div className="form-check mt-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="submitLater"
                                    name="submitLater"
                                    onChange={(e) => {
                                        if (e?.target?.checked) {
                                            setFileError(null);
                                        }
                                        handleCheckBox(e)
                                    }}
                                />
                                <label htmlFor="submitLater" className="form-check-label">I don't have this document</label>
                            </div>



                            <div className="row mt-3 mb-4">
                                <div className="col-auto d-flex justify-content-between">
                                    {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
                                    <button className="btn btn-primary btn-lg btn-block mt-3"
                                        onClick={(e) => handleSaveData(e)}
                                    >{lastCheck?'Submit':'Save'}
                                    </button>
                                </div>
                            </div>


                 {false && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                         onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
                        </> : 
                    <>
                    </>

                }
            </form>
        </>
    )
}

export default InsuffComponent;
